import { ErrorHandler, Injectable, inject, isDevMode } from '@angular/core';
import { LoggerErrorService } from '@cargos/sprintpay-services';
import Swal from 'sweetalert2';

@Injectable()
export class ApplicationErrorHandlerService implements ErrorHandler {
    private loggerErrorService = inject(LoggerErrorService);

    constructor() {}

    handleError(error: any): void {
        const errorText = this.extractErrorMessage(error);
        if (isDevMode()) {
            // eslint-disable-next-line no-console
            console.warn('Error occured:', error);
        }
        this.loggerErrorService.captureException(error);
        if (this.shouldIgnoreError(errorText)) {
            return;
        }
        Swal.fire({
            title: 'Error Ocurred',
            text: 'Something went wrong, please reload the page.',
            icon: 'error',
            showConfirmButton: true,
            confirmButtonText: 'Close',
            confirmButtonColor: '#007E59',
            allowOutsideClick: false,
        });
    }

    private extractErrorMessage(error: any): string {
        if (typeof error === 'string') {
            return error;
        }
        if (error instanceof Error) {
            return error.message;
        }
        if (error?.rejection?.message) {
            return error.rejection.message;
        }
        if (error?.toString) {
            return error.toString();
        }
        return 'Unknown Error';
    }

    private shouldIgnoreError(errorMessage: string): boolean {
        const keywordsToIgnore = ['radio_0'];
        return keywordsToIgnore.some((keyword) => errorMessage.includes(keyword));
    }
}
